import { render, staticRenderFns } from "./DynamicParcoursDetail.vue?vue&type=template&id=541ddc5a&"
import script from "./DynamicParcoursDetail.vue?vue&type=script&lang=js&"
export * from "./DynamicParcoursDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports